import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { mobile } from "@sellernote/ui/src/styles/functions";

import { fadeUpAnimation } from "../index.styles";

const container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0 64px 0;
  background-color: ${COLOR.primary_50};
  overflow: hidden;

  ${mobile(css`
    padding: 48px 0;

    ${fadeUpAnimation}
  `)}

  h3 {
    &.active {
      ${mobile(css`
        animation-delay: 0.2s;
      `)};
    }
  }
`;

const contentsContainer = styled.div`
  display: flex;
  margin-top: 36px;
  z-index: 1;

  ${mobile(css`
    flex-direction: column;
    margin-top: 24px;
    padding: 0 16px;
    width: 100%;
  `)}

  >.tab-wrapper {
    display: flex;
    align-items: center;

    ${mobile(css`
      overflow-x: scroll;
      margin-bottom: 24px;
      margin-right: -16px;
    `)}

    &.active {
      ${mobile(css`
        animation-delay: 0.4s;
      `)};
    }
  }

  .custom-tab > div {
    ${mobile(css`
      min-width: max-content;
    `)}
  }

  .image-container {
    position: relative;
    width: 800px;
    height: 448px;

    ${mobile(css`
      width: 100%;
      height: 0;
      padding-top: 55.83%;
    `)}

    &.active {
      ${mobile(css`
        animation-delay: 0.6s;
      `)};
    }
  }

  .image-wrapper {
    position: absolute;
    top: 0;
    opacity: 0;
    transition: opacity 0.2s cubic-bezier(0.65, 0, 0.35, 1);

    &.active {
      opacity: 1;
    }
  }
`;

const video = styled.video`
  width: 800px;
  height: 448px;
  object-fit: cover;

  ${mobile(css`
    width: 100%;
    height: 100%;
  `)}
`;

const quoteContainer = styled.div`
  position: absolute;
  width: 1128px;
  top: 0;
  bottom: 0;

  ${mobile(css`
    width: 100%;
  `)}

  .quote-left-wrapper {
    position: absolute;
    top: -25px;
    left: 61px;

    ${mobile(css`
      top: -16px;
      left: -10px;
    `)}
  }

  .quote-right-wrapper {
    position: absolute;
    bottom: -13px;
    right: 34px;

    ${mobile(css`
      bottom: -7px;
      right: -8px;
    `)}
  }
`;

export default {
  container,
  contentsContainer,
  video,
  quoteContainer,
};
